"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = onEnterPressed;

/**
 * Takes an onClick function and returns a new function for usage with keyboard
 * inputs, such as onKeyDown
 *
 * @param {Function} onClick
 *
 * @return {Function}
 */
function onEnterPressed(_ref) {
  var onClick = _ref.onClick,
      allowPropagation = _ref.allowPropagation;

  if (!onClick) {
    return null;
  }

  return function (event) {
    if (!allowPropagation) {
      event.preventDefault();
      event.stopPropagation();
    } // Keycode is deprecated in newer browsers but some old ones still use it


    if (event.which === 13 || event.keyCode === 13) {
      onClick(event);
    }
  };
}